import VerificationInputComponent from 'react-verification-input';

export const VerificationInput = VerificationInputComponent;
